import api from './AxiosInstance';

export class CotisationService {
 
  getAllCotis = async (selectedYear, selectedMonth) => {
    try {
      const response = await api.get(`/SaisieJournal/List/COTIS_SOC?annee=${selectedYear}&mois=${selectedMonth}`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };

  getTypeCotis = async () => {
    try {
      const response = await api.get(`/SaisieJournal/list/ByType?type=COTISATION`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };

  deleteCotis = async (dataNumPiece) => {
    try {
      const response = await api.post(`/SaisieJournal/Delete`,dataNumPiece,{

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };

  addCotis = async (dataNumPiece) => {
    try {
      const response = await api.post(`/SaisieJournal/addSaisie/COTIS_SOC`,dataNumPiece,{

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };
//
 
}


